(function () {
  var KEY = 'll_wishlist_v1';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(items) { localStorage.setItem(KEY, JSON.stringify(items)); broadcast(); }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function add(item) { var items = read(); if (!has(item.handle)) { items.unshift(item); write(items); } }
  function remove(handle) { write(read().filter(function (i) { return i.handle !== handle; })); }
  function toggle(item) { has(item.handle) ? remove(item.handle) : add(item); return has(item.handle); }
  function count() { return read().length; }

  function broadcast() {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      var c = count();
      el.textContent = c;
      el.hidden = c === 0;
    });
    document.dispatchEvent(new CustomEvent('ll:wishlist:change'));
  }

  function itemFromBtn(b) {
    return {
      handle:    b.getAttribute('data-wishlist-handle'),
      title:     b.getAttribute('data-wishlist-title'),
      url:       b.getAttribute('data-wishlist-url'),
      image:     b.getAttribute('data-wishlist-image'),
      price:     b.getAttribute('data-wishlist-price'),
      variant:   b.getAttribute('data-wishlist-variant'),
      available: b.getAttribute('data-wishlist-available') === 'true',
      options:   b.getAttribute('data-wishlist-options') === 'true'
    };
  }

  function syncHearts() {
    document.querySelectorAll('.ll-wish[data-wishlist-handle]').forEach(function (b) {
      var on = has(b.getAttribute('data-wishlist-handle'));
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  // Toggle from any heart (event-delegated so it covers AJAX-loaded grids too)
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.ll-wish');
    if (!b) return;
    e.preventDefault();
    var saved = toggle(itemFromBtn(b));
    b.classList.toggle('is-saved', saved);
    b.setAttribute('aria-pressed', saved ? 'true' : 'false');
    if (saved) { b.classList.remove('pulse'); void b.offsetWidth; b.classList.add('pulse'); }
  });

  window.addEventListener('storage', function (e) { if (e.key === KEY) { syncHearts(); broadcast(); } });
  document.addEventListener('shopify:section:load', syncHearts); // theme-editor re-renders
  document.addEventListener('DOMContentLoaded', function () { syncHearts(); broadcast(); });

  // ---- Wishlist PAGE rendering ----
  function money(s) { return s || ''; }

  function cardHTML(i) {
    var img = i.image
      ? '<img src="' + i.image + '" alt="' + (i.title || '') + '" loading="lazy">'
      : '';
    var action = i.options
      ? '<a href="' + i.url + '" class="ll-wish-card__btn">choose options</a>'
      : (i.available && i.variant
          ? '<form method="post" action="/cart/add" class="ll-wish-add">' +
              '<input type="hidden" name="id" value="' + i.variant + '">' +
              '<input type="hidden" name="quantity" value="1">' +
              '<button type="submit" class="ll-wish-card__btn">add to basket</button>' +
            '</form>'
          : '<button class="ll-wish-card__btn is-disabled" disabled>sold out</button>');
    return '' +
      '<div class="ll-wish-card" data-handle="' + i.handle + '">' +
        '<a class="ll-wish-card__img" href="' + i.url + '">' + img +
          '<button type="button" class="ll-wish-card__remove" aria-label="Remove ' + (i.title || 'item') + ' from wishlist" data-remove="' + i.handle + '">&times;</button>' +
        '</a>' +
        '<a class="ll-wish-card__title" href="' + i.url + '">' + (i.title || '') + '</a>' +
        '<div class="ll-wish-card__price">' + money(i.price) + '</div>' +
        action +
      '</div>';
  }

  function renderPage() {
    var root = document.getElementById('ll-wishlist-app');
    if (!root) return;
    var grid  = root.querySelector('.ll-wish__grid');
    var empty = root.querySelector('.ll-wish__empty');
    var meta  = root.querySelector('.ll-wish__meta');
    var items = read();

    if (!items.length) {
      grid.hidden = true; grid.innerHTML = '';
      empty.hidden = false;
      if (meta) meta.textContent = '';
      return;
    }
    empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = items.map(cardHTML).join('');
    if (meta) meta.textContent = items.length + (items.length === 1 ? ' saved' : ' saved') + ' · kept safe on this device';
  }

  document.addEventListener('click', function (e) {
    var r = e.target.closest('[data-remove]');
    if (!r) return;
    e.preventDefault();
    remove(r.getAttribute('data-remove'));
    renderPage();
  });

  // Progressive-enhance the wishlist-page add buttons → AJAX cart (graceful fallback to form post)
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('.ll-wish-add');
    if (!f) return;
    if (!window.fetch) return; // let the normal form post happen
    e.preventDefault();
    var btn = f.querySelector('button');
    var id  = f.querySelector('input[name="id"]').value;
    if (btn) { btn.classList.add('added'); btn.textContent = 'added ✓'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (res) {
      // refresh Dawn cart bubble; open the drawer if present, else go to cart
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        return fetch('/?sections=cart-drawer,cart-icon-bubble').then(function(r){return r.json();}).then(function(s){
          if (s['cart-drawer']) drawer.classList.remove('is-empty');
          drawer.open && drawer.open();
        });
      } else {
        window.location.href = '/cart';
      }
    }).catch(function () { window.location.href = '/cart'; })
      .finally(function () { if (btn) setTimeout(function(){ btn.classList.remove('added'); btn.textContent='add to basket'; }, 1600); });
  });

  document.addEventListener('DOMContentLoaded', renderPage);
  document.addEventListener('shopify:section:load', renderPage);
  document.addEventListener('ll:wishlist:change', function(){ /* page re-render handled on explicit actions */ });

  window.LLWishlist = { read: read, remove: remove, count: count };
})();
